export default "__VITE_ASSET__BUjmgoDS__"